import React, { useState, useEffect } from 'react';
import './ProfileModal.css';

function ProfileModal({ user, onClose, onUserUpdate, initialEditing = false, initialStatusMessage = '' }) {
  const [username, setUsername] = useState(user.username || '');
  const [editing, setEditing] = useState(initialEditing || !!user.username_pending);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (initialEditing) setEditing(true);
    if (user.username_pending) setEditing(true);
  }, [initialEditing, user.username_pending]);

  if (!user) return null;

  const handleUsernameChange = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    try {
      const res = await fetch('/api/user/change-username', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newUsername: username.trim() }),
        credentials: 'include',
      });

      if (!res.ok) {
        const data = await res.json();
        setErrorMessage(data.error || 'Failed to change username');
        return; // keep editing mode open
      }

      // Fetch fresh user data from /api/me
      const meRes = await fetch('/api/me', { credentials: 'include' });
      if (!meRes.ok) {
        setErrorMessage('Failed to fetch updated user data');
        return;
      }
      const updatedUser = await meRes.json();
      if (onUserUpdate) onUserUpdate(updatedUser);
      setEditing(false);
    } catch (err) {
      setErrorMessage('Network error');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal profile-modal" onClick={e => e.stopPropagation()}>
        <h2>My Profile</h2>
        <div style={{ marginBottom: 12 }}>
          <strong>Username:</strong>{' '}
          {editing ? (
            <form onSubmit={handleUsernameChange} style={{ display: 'inline' }}>
              <input
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoFocus
                style={{ width: 130 }}
                maxLength={32}
                required
              />{' '}
              <button type="submit">Save</button>
              <button
                type="button"
                onClick={() => {
                  setEditing(false);
                  setUsername(user.username);
                  setErrorMessage('');
                }}
              >
                Cancel
              </button>
            </form>
          ) : (
            <>
              <span>{username}</span>{' '}
              <button
                type="button"
                onClick={() => {
                  setEditing(true);
                  setErrorMessage('');
                }}
              >
                Edit
              </button>
            </>
          )}
        </div>
        {errorMessage && <div style={{ color: 'red', marginBottom: 12 }}>{errorMessage}</div>}
        <div style={{ marginBottom: 12 }}>
          <strong>Email:</strong> <span>{user.email}</span>
        </div>
        {user.role && (
          <div style={{ marginBottom: 12 }}>
            <strong>Role:</strong> <span>{user.role}</span>
          </div>
        )}
        {user.created_at && (
          <div style={{ marginBottom: 12 }}>
            <strong>Joined:</strong> <span>{new Date(user.created_at).toLocaleDateString()}</span>
          </div>
        )}
        <button onClick={onClose} style={{ marginTop: 12 }}>
          Close
        </button>
      </div>
    </div>
  );
}

export default ProfileModal;
